import logger from '@tcp/core/src/utils/loggerInstance';
import {
  isAPITriggerLoggerEnabled,
} from '@tcp/core/src/utils';
import trackerObject from './config';

export default class ApiTriggerTracker {
  constructor() {
    if (!ApiTriggerTracker.instance) {
      // Private variables and methods can be defined here
      this.queriesToListen = [];
      this.trackerObject = { ...trackerObject };
      ApiTriggerTracker.instance = this;
    }
    return ApiTriggerTracker.instance;
  }

  logError(key) {
    if(!isAPITriggerLoggerEnabled()) {
      return;
    }
    const item = this.trackerObject[key];

    if (item.startListening && !item.invoked) {
      logger.error({
        error: `ApiTriggerTracker - ${key} API Not fired`,
      });
    }
    const index = this.queriesToListen.indexOf(key);
    if (index > -1) {
      this.queriesToListen.splice(index, 1);
    }
    if(this.trackerObject[key] && this.trackerObject[key].startListening){
      this.trackerObject[key].startListening = false;
    }
  }

  getTrackerObject() {
    return this.trackerObject;
  }

  setInvokedValue(query, value) {
    if (this.trackerObject[query] === -1) {
      return false;
    }
    this.trackerObject[query].invoked = value;
    return this.trackerObject;
  }

  startListener(query) {
    try {
      if(!isAPITriggerLoggerEnabled()) {
        return;
      }
      if (this.queriesToListen.includes(query)) {
        return; // Stop execution if the query is already being listened to
      }

      const { validationErrorSelectors,listenTimeout } = this.trackerObject[query];

      let allErrorElementsMissing = true; // Flag to track if all elements are missing
      validationErrorSelectors.forEach((selector) => {
        const errorElements = document.querySelectorAll(selector);
        if(errorElements){
          errorElements.forEach(selector1 => {
            if(selector1.innerText?.trim().length > 0) {
              allErrorElementsMissing = false;
            }
          });
        }
      });

      if (allErrorElementsMissing) {
        this.queriesToListen.push(query);
        this.trackerObject[query].startListening = true;
        setTimeout(() => this.logError(query), listenTimeout);
      }
    }catch {
      console.log("Error in ApiTriggerTracker")
    }
  }
}
